import React from 'react';
import Copy from '../../../assets/Copy';
import MailDone from '../../../assets/MailDone';
import s from './Loader.module.scss';
export const Loader = ({ ...parameters }: any) => {
  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <div className={s.dot}></div>
      </div>
      {parameters.text && <div className={s.title}>{parameters.text}</div>}
    </div>
  );
};
